import { Flex, Space, Dropdown } from "antd";
import styled from "styled-components";

export const StyledFlex = styled(Flex)`
  justify-content: space-between;
  align-items: center;
  height: 2rem;
  background-color: transparent;
`;

export const HeaderHeadline = styled.h1`
  font-size: 36px;
  font-weight: bold;
  font-family: "Alef", sans-serif;
`;

export const StyledDropdown = styled(Dropdown)`
  direction: rtl;
`;
